import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Emailed reset exists only in Cloud; Local POS passwords are managed on the device.
export const ForgotPasswordLink = () => {
  const [cloud, setCloud] = useState(false);
  useEffect(() => {
    let live = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/pos/mode`)
      .then(({ data }) => { if (live) setCloud(data?.mode !== 'local_pos'); })
      .catch(() => { if (live) setCloud(false); });
    return () => { live = false; };
  }, []);
  return cloud ? <Link to="/reset-password" data-testid="landing-forgot-password"
    className="block text-right text-xs underline underline-offset-4 hover:opacity-75"
    style={{ color: 'var(--text-secondary)' }}>Нууц үгээ мартсан?</Link> : null;
};
